// src/components/auth/ProtectedRoute.jsx - VERSÃO CORRIGIDA
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

// Componente para rotas protegidas básicas (apenas usuários logados)
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

// Componente para proteção baseada em roles
const RoleProtectedRoute = ({ children, allowedRoles = [], fallbackPath = '/dashboard' }) => {
  const authContext = useAuth();

  // Verificação de segurança: se o contexto de auth não existe
  if (!authContext) {
    console.error('RoleProtectedRoute: useAuth context não encontrado');
    return <Navigate to="/login" replace />;
  }

  const { hasRole, loading } = authContext;

  // Verificação de segurança: se hasRole não é uma função
  if (typeof hasRole !== 'function') {
    console.error('RoleProtectedRoute: hasRole não é uma função');
    return <Navigate to="/login" replace />;
  }

  // Aguardar carregamento da autenticação
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">Carregando...</div>
      </div>
    );
  }

  // Verificação de segurança: se allowedRoles não foi definido ou está vazio
  if (!Array.isArray(allowedRoles) || allowedRoles.length === 0) {
    console.warn('RoleProtectedRoute: allowedRoles deve ser um array não vazio', allowedRoles);
    return <Navigate to={fallbackPath} replace />;
  }

  // Verificar se o usuário tem pelo menos um dos roles permitidos
  try {
    const hasRequiredRole = allowedRoles.some(role => {
      if (typeof role !== 'string') {
        console.warn('RoleProtectedRoute: role deve ser uma string', role);
        return false;
      }
      return hasRole(role);
    });

    if (!hasRequiredRole) {
      console.log('RoleProtectedRoute: Usuário não tem permissão. Roles necessários:', allowedRoles);
      return <Navigate to={fallbackPath} replace />;
    }
  } catch (error) {
    console.error('RoleProtectedRoute: Erro ao verificar roles:', error);
    return <Navigate to="/login" replace />;
  }

  return children;
};

// Componente específico para rotas administrativas
export const AdminRoute = ({ children }) => (
  <RoleProtectedRoute allowedRoles={['admin']} fallbackPath="/dashboard">
    {children}
  </RoleProtectedRoute>
);

// Componente específico para rotas de expositores
export const ExpositorRoute = ({ children }) => (
  <RoleProtectedRoute allowedRoles={['expositor', 'admin']} fallbackPath="/login">
    {children}
  </RoleProtectedRoute>
);

export default ProtectedRoute;
export { RoleProtectedRoute };